"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 15c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1zm-5.71-9.3a.996.996 0 0 0-1.41 0L12 10.59 10.11 8.7a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 8.7 13.89c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0L12 13.41l1.89 1.89c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L13.41 12l1.89-1.89c.38-.38.38-1.02-.01-1.41"
}), 'CancelPresentationRounded');